import PropTypes from 'prop-types'

import './index.css'

// Walmart affiliate — matches the hardcoded promo shown on fycdeals.com's
// real Deal component for affiliate id 4, replicated here for full preview
// fidelity
const WALMART_AFFILIATE_ID = 4

const displayDollar = (val) => {
    const num = Number.parseFloat(val)
    return Number.isNaN(num) ? '$0.00' : `$${num.toFixed(2)}`
}

const displayPercent = (val) => {
    const num = Number.parseFloat(val)
    return Number.isNaN(num) ? '0%' : `${num.toFixed(2)}%`
}

const getDiscountPercent = (value) => {
    const final = Number.parseFloat(value.priceFinal)
    const original = Number.parseFloat(value.priceOriginal)

    if (!original || Number.isNaN(final) || final >= original)
        return null

    return displayPercent((1 - (final / original)) * 100)
}

const getPercentageOrAmount = (value) => {
    if (value.couponClickablePercentage) {
        return displayPercent(value.couponClickablePercentage)
    } else if (value.couponClickableAmount) {
        return displayDollar(value.couponClickableAmount)
    }

    return null
}

const DealPreviewCardComponent = ({ value={}, config={} }) => {
    const discountPercent = getDiscountPercent(value)
    const percentageOrAmount = getPercentageOrAmount(value)
    const hasCouponInstructions = value.couponClickablePercentage || value.couponClickableAmount || value.couponRedeemableDescription || value.couponPromoCode

    const handleCopyToClipboard = () => {
        navigator.clipboard.writeText(value.couponPromoCode)
    }

    return (
        <div className="c-DealPreviewCard">
            {value.deadDate ? (
                <div className="dealPreviewCard-dead">DEAD</div>
            ) : null}

            <div className="dealPreviewCard-affiliate">{config.affiliateName || 'Affiliate'}</div>

            <div className="dealPreviewCard-header">
                <div className="dealPreviewCard-title">{value.name || 'Deal name'}</div>
                {discountPercent ? <span className="dealPreviewCard-discountBubble">-{discountPercent}</span> : null}
            </div>

            <div className="dealPreviewCard-details">
                <div
                    className="dealPreviewCard-thumb"
                    style={value.imageUrl ? { backgroundImage: `url(${value.imageUrl})` } : undefined}
                />

                <div className="dealPreviewCard-body">
                    {value.description ? <div className="dealPreviewCard-description">{value.description}</div> : null}

                    {Number(value.affiliateId) === WALMART_AFFILIATE_ID ? (
                        <div className="dealPreviewCard-customMessage">
                            Get <strong>FREE SHIPPING</strong> on this deal with a <strong>Walmart+ Membership</strong> Free 30-Day Trial ›
                        </div>
                    ) : null}

                    <div className="dealPreviewCard-price">
                        <span className="now">{displayDollar(value.priceFinal)}</span>
                        {value.priceOriginal ? <span className="was">{displayDollar(value.priceOriginal)}</span> : null}
                    </div>
                </div>
            </div>

            {hasCouponInstructions ? (
                <div className="dealPreviewCard-instructions">
                    <div className="dealPreviewCard-instructionsTitle">How To Get Discount Price</div>
                    <ul className="dealPreviewCard-instructionsList">
                        {percentageOrAmount ? (
                            <li>Click {percentageOrAmount} coupon on product page</li>
                        ) : null}

                        {value.couponRedeemableDescription ? (
                            <li>{value.couponRedeemableDescription}</li>
                        ) : null}

                        {value.couponPromoCode ? (
                            <li>
                                Enter <span className="dealPreviewCard-promoBubble" onClick={handleCopyToClipboard}>{value.couponPromoCode}</span> at checkout
                            </li>
                        ) : null}
                    </ul>
                </div>
            ) : null}

            <div className="dealPreviewCard-ctas">
                <div className="dealPreviewCard-cta dealPreviewCard-ctaReportDead">Report Dead</div>
                <div className="dealPreviewCard-cta dealPreviewCard-ctaViewDeal">View Deal</div>
            </div>
        </div>
    )
}

DealPreviewCardComponent.propTypes = {
    value: PropTypes.object,

    config: PropTypes.shape({
        affiliateName: PropTypes.string
    })
}

export { DealPreviewCardComponent }
